import { Book, MenuBook, PictureAsPdf } from "@mui/icons-material";
import { Box, Button, Typography, useColorScheme } from "@mui/joy";
import { ref, runTransaction } from "firebase/database";
import HatchlingCover from "../assets/Hatchling/HatchlingCover.webp";
import { database } from "../utils/firebase";

export default function HatchlingPreludeSection() {
  const { mode } = useColorScheme();
  const isDark = mode === "dark";
  const emberColor = "rgba(239, 68, 68, 0.8)";

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Typography
        level="h3"
        component="a"
        id="hatchlingOfTheOrchard"
        sx={{
          color: emberColor,
          letterSpacing: "0.05em",
          textAlign: "center",
        }}
      >
        HATCHLING OF THE ORCHARD
      </Typography>
      <Typography
        level="body-sm"
        sx={{
          color: isDark ? "rgba(255, 255, 255, 0.7)" : "rgba(30, 41, 59, 0.7)",
          mb: 2,
          textAlign: "center",
        }}
      >
        A Prelude to The Ember Tide
      </Typography>
      <Typography level="body-xs" sx={{ mb: 3 }}>
        Copyright © 2025 Mostafa Elbehery & Aly Said, All rights reserved.
      </Typography>

      <img
        src={HatchlingCover}
        width={"550px"}
        alt="Hatchling of the Orchard Cover"
        style={{ borderRadius: "8px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "550px",
          width: "100%",
        }}
      >
        {/* PDF Download */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            mt: 4,
            width: "100%",
            gap: 2,
          }}
        >
          <Button
            aria-label="Download PDF"
            sx={{
              flex: 1,
              bgcolor: isDark ? "rgba(127, 29, 29, 0.3)" : "rgba(254, 226, 226, 0.8)",
              color: isDark ? "rgba(252, 165, 165, 1)" : "rgba(153, 27, 27, 1)",
              borderColor: isDark ? "rgba(185, 28, 28, 0.5)" : "rgba(185, 28, 28, 0.3)",
              "&:hover": {
                bgcolor: isDark ? "rgba(127, 29, 29, 0.5)" : "rgba(254, 202, 202, 1)",
              },
            }}
            variant="outlined"
            component="a"
            href="/assets/Timeless' Aria - Hatchling of the Orchard.pdf"
            download
            onClick={() => {
              runTransaction(ref(database, "hatchling-pdf"), (currentValue) => {
                return (currentValue || 0) + 1;
              });
            }}
            startDecorator={<PictureAsPdf />}
          >
            Download PDF
          </Button>
        </Box>

        {/* Paperback Purchase */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            mt: 2,
          }}
        >
          <Button
            aria-label="Paperback Version on Amazon"
            sx={{
              flex: 1,
              background: `linear-gradient(45deg, ${emberColor}, ${emberColor}cc) !important`,
              "&:hover": {
                background: `linear-gradient(45deg, ${emberColor}cc, ${emberColor}) !important`,
              },
            }}
            component="a"
            href="https://amzn.eu/d/dzTBm7l"
            target="_blank"
            startDecorator={<Book />}
            size="lg"
            variant="solid"
            color="neutral"
          >
            Get Paperback on Amazon
          </Button>
        </Box>

        {/* Read Online */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            mt: 2,
          }}
        >
          <Button
            aria-label="Read Online"
            sx={{
              flex: 1,
              bgcolor: isDark ? "rgba(127, 29, 29, 0.2)" : "rgba(254, 242, 242, 1)",
              color: isDark ? "rgba(252, 165, 165, 1)" : "rgba(153, 27, 27, 1)",
              "&:hover": {
                bgcolor: isDark ? "rgba(127, 29, 29, 0.4)" : "rgba(254, 226, 226, 1)",
              },
            }}
            variant="soft"
            component="a"
            href="/hatchling"
            onClick={() => {
              runTransaction(
                ref(database, "hatchling-reader"),
                (currentValue) => {
                  return (currentValue || 0) + 1;
                }
              );
            }}
            startDecorator={<MenuBook />}
          >
            Read Online with Interactive Features
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
